import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EDeleteNewbuildingFromComparisonActionTypes {
  Success = 'DELETE_NEWBUILDING_FROM_COMPARISON/SUCCESS',
}

interface IPayload {
  newbuildingId: number;
}

type TDeleteNewbuildingFromComparisonSuccess = ITypedReduxAction<
  EDeleteNewbuildingFromComparisonActionTypes.Success,
  IPayload
>;

export type TDeleteNewbuildingFromComparison = TDeleteNewbuildingFromComparisonSuccess;

export const deleteNewbuildingFromComparisonSuccess = actionGenerator<
  EDeleteNewbuildingFromComparisonActionTypes.Success,
  IPayload
>(EDeleteNewbuildingFromComparisonActionTypes.Success);
